var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content wrapper wrapper--medium"},[_c('portal-target',{attrs:{"name":"next-status-level"}}),_c('Modules'),_c('BankStatus'),_c('click-blocker')],1)}
var staticRenderFns = []

export { render, staticRenderFns }